// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"legal_legalContainer__hGIMa","legalLinksContainer":"legal_legalLinksContainer__MhAuC","legalLink":"legal_legalLink__G5i_6","copyright":"legal_copyright__5tlsq"};